import { useLanguage } from '../contexts/LanguageContext';
import esTranslations from '../translations/es.json';
import enTranslations from '../translations/en.json';

const translations = {
  es: esTranslations,
  en: enTranslations
};

export const useTranslations = () => {
  const { language } = useLanguage();
  
  const t = (key, options = {}) => {
    const { returnObjects = false, defaultValue = null, ...params } = options;
    const keys = key.split('.');
    let value = translations[language];
    
    // Intentar con el idioma actual primero
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        // Solo hacer fallback si no existe la clave en el idioma actual
        let fallbackValue = null;
        
        // Intentar fallback al inglés solo si no estamos ya en inglés
        if (language !== 'en' && translations.en) {
          let enValue = translations.en;
          for (const k of keys) {
            if (enValue && enValue[k] !== undefined) {
              enValue = enValue[k];
            } else {
              enValue = null;
              break;
            }
          }
          fallbackValue = enValue;
        }
        
        // Si no hay fallback disponible, usar defaultValue
        if (fallbackValue) {
          value = fallbackValue;
          break;
        } else if (defaultValue) {
          return defaultValue;
        } else {
          // Fallback final según el idioma
          const fallbacks = {
            'terms.title': language === 'es' ? 'Términos y Condiciones' : 'Terms & Conditions',
            'terms.lastUpdated': language === 'es' ? 'Última actualización: Enero 2025' : 'Last updated: January 2025',
            'privacy.title': language === 'es' ? 'Política de Privacidad' : 'Privacy Policy',
            'privacy.lastUpdated': language === 'es' ? 'Última actualización: Enero 2025' : 'Last updated: January 2025'
          };
          return fallbacks[key] || (language === 'es' ? 'Contenido no disponible' : 'Content not available');
        }
      }
    }
    
    // Si se solicitan objetos/arrays, devolverlos directamente
    if (returnObjects) {
      return value !== undefined ? value : (defaultValue || (language === 'es' ? 'Contenido no disponible' : 'Content not available'));
    }
    
    // Si no hay valor o no es string, devolver fallback
    if (!value || typeof value !== 'string') {
      return defaultValue || (language === 'es' ? 'Contenido no disponible' : 'Content not available');
    }
    
    // Reemplazar placeholders con parámetros
    let result = value;
    Object.keys(params).forEach(param => {
      const placeholder = `{{${param}}}`;
      result = result.replace(new RegExp(placeholder, 'g'), params[param]);
    });
    
    return result;
  };

  return { t, language };
};